// common values shared between UI and tests
export const dataHooks = {
  search: 'selector-list-search',
  content: 'selector-list-content',
  mainLoader: 'selector-list-main-loader',
  emptyState: 'selector-list-empty-state',
  nextPageLoader: 'selector-list-next-page-loader',
  noResultsFoundState: 'selector-list-no-results-found-state',
  selector: 'selector-list-selector',
  list: 'selector-list-list',
  toggleAllCheckbox: 'selector-list-toggle-all-checkbox',
  subtitle: 'selector-list-subtitle',
};
